import styled from 'styled-components';

import media from '@/styles/media.style';
import { BG_GRAY } from '@/styles/variables.style';

export const Hr = styled.div`
  width: 30px;
  height: 2px;
  background: ${BG_GRAY.COMMON_6};
  margin: 0 calc(50% - 15px);
`;

export const PlaceholderWrapper = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'column'};
  width: 100%;

  &.wrapper {
    margin: 0 20px;

    ${media.tabletL`
      margin: auto;
    `};
  }

  &.sectionHeader {
    align-items: center;
  }

  &.overviewSection,
  &.linkSection,
  &.carouselSection {
    display: flex;
    align-items: center;
    width: calc(100% - 40px);
    margin: 15px 20px 40px;

    ${media.tabletL`
      width: 100%;
      max-width: ${({ maxWidth }) => maxWidth || '1050px'};
      min-width: 60vh;
      min-height: 60vh;
      margin: ${({ margin }) => margin || '50px auto 90px'};
    `};

    ${media.desktop`
      width: 100%;
      max-width: ${({ maxWidth }) => maxWidth || '1050px'};
      min-width: 900px;
      min-height: ${({ minHeight }) => minHeight || '650px'};
      margin: 50px auto 90px;
    `};
  }

  &.contentPlaceholder {
    flex-direction: column;
    justify-content: center;
    margin: 0;
    order: 0;

    ${media.tabletL`
      width: calc(50% - 90px);
      margin: ${({ left }) => (left ? '0 20px 0 90px' : '0 90px 0 20px')};
      order: ${({ left }) => (left ? '0' : '-1')};
    `};
  }

  &.contentImagePlaceholder {
    width: 100%;
    height: 251px;

    ${media.tabletL`
      width: 50%;
      height: 540px;
    `};
  }

  &.contentPlaceholderChild {
    flex-direction: column;
    justify-content: center;
    height: 112px;
    margin-right: 20px;

    ${media.tabletL`
      align-items: flex-start;
      margin-right: 0;
    `};
  }
`;



// WEBPACK FOOTER //
// ./src/pages/NewsAndEventsDetailsPage/NewsAndEventsDetailsPage.style.js